var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(" Accès non autorisé ")]),_c('div',[_c('p',[_vm._v(" Vous n'avez pas accès à l'application Culturial ")]),_c('AgrButton',{staticClass:"ma-5",attrs:{"outlined":""},on:{"click":function($event){return _vm.onLogout()}}},[_c('v-icon',[_vm._v("mdi-power")]),_vm._v(" Se déconnecter ")],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }